/**
 * <pre>
 * State service.
 *
 * Summary of responsibilities:
 *
 *  - provides abstraction layer for access to state data.
 * </pre>
 *
 * @author Various
 * @namespace Common.Services.StateService
 */
const StateService = (function() {

	'use strict';

	// State.
	var state;

	// Legacy state.
	var _legacyState;

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	/**
	 * Init.
	 *
	 * @memberOf Common.Services.StateService
	 *
	 * @param legacyState 		{object} Refefence to the legacy NGX app state object.
	 */
	const init = (legacyState) => {

		// Store injected params.
		_legacyState = legacyState;

		// For now, just grab the parts of the legacy state we need and map them across as desired...
		state = {

			// Window related.
			window: {
				framed: 			'{eval:framed}',
				embedApiAvailable: 	'{eval:useApi}'
			},

			// User related.
			user: {
				fb: {
					id: 			'{eval:currentUser.userSession.authResponse.userID}',
					token: 			'{eval:currentUser.userSession.authResponse.accessToken}'
				}
			}
		}
	};

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Mutator Methods.

	/**
	 * Get a state key. Use dot notation to access nested properties.
	 *
	 * @memberOf Common.Services.StateService
	 *
	 * @param stateKey {string} String containing dot notation of state property.
	 * @param stateStore {object} The state object to look in. Defaults to state.
	 * @return {mixed} The matching state property.
	 */
	const get = (stateKey, stateStore=state) => {

		let i, len, def;

		// If no key was supplied, return everything.
		if(!stateKey) {
			return stateStore;
		}

	    // Recursively reduce the state object untill we are left with the matching value.
	    let matchedState = stateStore;
	    for(i = 0,stateKey = stateKey.split('.'), len = stateKey.length; i < len; i++) {
	        if(!matchedState || typeof matchedState !== 'object') {
	        	return def;
	        }
	        matchedState = matchedState[stateKey[i]];
	    }

	    if(matchedState === undefined) return def;

		// Evalulate value if required.
		if(typeof(matchedState) === 'string') {

			if(matchedState.indexOf('{eval:') !== -1) {
				matchedState = matchedState.replace('{eval:', '');
				matchedState = matchedState.replace('}', '');

				// Recurse.
				matchedState = get(matchedState, _legacyState);
			}
		}

	    return matchedState;
	};

	// Expose scoped properties.
	return {

		init: 	init,
		get: 	get
	}

}());

export default StateService;